import clsx from 'clsx'

import { DisruptionStatus } from '@/types/disruptions'
import styles from './Status.module.scss'

import CheckMarkIcon from '../../assets/checkmark.svg'
import WarningIcon from '../../assets/warning.svg'

interface Props {
    status: DisruptionStatus
    isHeader?: boolean
}

export const Status = ({ status, isHeader = false }: Props) => {
    return (
        <div
            className={clsx(styles.root, styles[status.toLowerCase()], {
                [styles.header]: isHeader,
            })}
        >
            {status === DisruptionStatus.Live && <WarningIcon />}
            {status === DisruptionStatus.Cleared && <CheckMarkIcon />}
            {status}
        </div>
    )
}
